import type { SentryEventFilter } from '../types'

export const filterIgnoredStatusCode: SentryEventFilter = ({ statusCode }) => {
  const parsedStatusCode = Number(statusCode)

  return parsedStatusCode > 399 && parsedStatusCode < 404
}
